import React from 'react';

import { 
    FaTwitter,
    FaTumblr,
    FaGooglePlusG,
    FaFacebookF,
    FaLinkedinIn,
    FaSlack,
    FaMediumM,
    FaTelegramPlane,
    FaSnapchatGhost,
    FaPinterestP,
    FaYoutube,
  } from "react-icons/fa";

  export default {
    links : [
        {
            icon: <FaTwitter />,
            url: "#"
        },
        {
            icon: <FaTumblr />,
            url: "#"
        },
        {
            icon: <FaGooglePlusG />,
            url: "#"
        },
        {
            icon: <FaFacebookF />,
            url: "#"
        },
        {
            icon: <FaLinkedinIn />,
            url: "#"
        },
        {
            icon: <FaSlack />,
            url: "#"
        },
        {
            icon: <FaMediumM />,
            url: "#"
        },
        {
            icon: <FaTelegramPlane />,
            url: "#"
        },
        {
            icon: <FaSnapchatGhost />,
            url: "#"
        },
        {
            icon: <FaPinterestP />,
            url: "#"
        },
        {
            icon: <FaYoutube />,
            url: "#"
        }
    ]
  }